import React, { useState } from "react";
import Footer from "../components/footer";
import Header from "../components/header";

const Contact=()=>{

    const [formData, setFormData] = useState({
        name: "",
        contact: "",
        email: "",
        message: "",
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value,
        }));
    };

    const handleSubmit = async () => {
        if (!formData.name || !formData.email || !formData.message) {
            alert("Please fill out all required fields.");
            return;
        }

        try {
            debugger;
            const response = await fetch("http://localhost:5000/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                alert("Your message has been sent successfully!");
                setFormData({
                    name: "",
                    contact: "",
                    email: "",
                    message: "",
                });
            } else {
                alert("Failed to send your message. Please try again later.");
            }
        } catch (error) {
            console.error("Error sending email:", error);
            alert("An error occurred. Please try again.");
        }
    };


    return(
        <>
        <Header />
            <section className="pageheader">
                <div class="container">
                    <h2 className="heading" data-aos="zoom-in" data-aos-duration="700">Contact Us</h2>
                </div>
            </section>
            <section className="dark_theam">
                <div className="container">
                    <div className="light-box p-5">                
                        <div className="row">  
                        <div className="h4" data-aos="fade-up" data-aos-duration="900">Find out how you can be a part of the Ez Scan Go revolution.</div>                          
                            
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="col-sm-12 form">
                        <div className="row">
                            <div className="form-group col-md-6">
                                <div className="p-2">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="name" 
                                        placeholder="Your Full Name" 
                                        value={formData.name}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className="form-group col-md-6">
                                <div className="p-2">
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="contact" 
                                        placeholder="Your Conatct Number" 
                                        value={formData.contact}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group p-2">
                            <input 
                                type="text" 
                                className="form-control" 
                                id="email" 
                                placeholder="Email Address" 
                                value={formData.email}
                                onChange={handleChange}
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group p-2">
                            <textarea 
                                className="form-control" 
                                placeholder="Your message here" 
                                id="message"
                                value={formData.message}
                                onChange={handleChange} 
                                autoComplete="off"  
                                > 
                                                   
                            </textarea>
                        </div>
                        <div className="p-2">
                            <button type="button" id="" className="btn-style1 bg-white text-black pt-3 pb-3" onClick={handleSubmit}><i className="fas fa-paper-plane"></i> Submit</button>
                        </div>
                    </div>
                </div>
            </section>
        <Footer />
        </>
    )
};
export default Contact;